import React from "react";
import { Menu, withStyles } from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";

import {
  Button,
  MenuItem,
  SelectWrapper
} from "./styles";

const StyledMenu = withStyles( theme => ({
  paper: {
    border: theme.name === 'dark' ? `1px solid ${theme.palette.secondary.main}` : 'none',
    marginTop: theme.heightRatio*5,
    background: theme.palette.primary.main,
    boxShadow: '0 2px 32px 4px rgba(0, 0, 0, 0.2)',
    minWidth: theme.widthRatio * 55
  },
}))((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'left',
    }}
    {...props}
  />
));

const CustomSelect = (props) => {

  const { value, onChange, options } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleOpen = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (e) => {
    onChange(e.target.value);
    setAnchorEl(null);
  };

  return (
    <SelectWrapper>
      <Button
        onClick={handleOpen}
        opened={anchorEl ? 'true' : ''}
      >
        <span className='label'>{value}</span> <ExpandMore/>
      </Button>
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        style={{width: `100px !important`}}
      >
        {
          options.map(menu => (
            <MenuItem
              key={menu.value}
              onClick={handleClick}
              value={menu.value}
              selected={value === menu.value}
            >
              {menu.label}
            </MenuItem>
          ))
        }
      </StyledMenu>
    </SelectWrapper>
  );
};

export default CustomSelect;
